import { API_PREFIX } from "./api.constants";

const V1_USERS_PREFIX = `${API_PREFIX}/users`;
const V1_PROFILE_FIELDS_PREFIX = `${API_PREFIX}/user-profile-fields`;

export const USER_ENDPOINTS = {
  USER: `${V1_USERS_PREFIX}/`,
  /** People who manage someone in the tenant — {id, name}[] (report "Manager" filters). */
  MANAGERS: `${V1_USERS_PREFIX}/managers`,
  USER_DETAIL: (id: number | string): string => `${V1_USERS_PREFIX}/${id}`,
  USER_PASSWORD: (id: number) => `${V1_USERS_PREFIX}/${id}/password`,
  /** POST — the server generates a password and e-mails it to the user; the response only says where it went. */
  USER_PASSWORD_GENERATE: (id: number) => `${V1_USERS_PREFIX}/${id}/password/generate`,
  /** PUT {current_password, new_password} — the signed-in user changes their own password (tenant policy applies). */
  MY_PASSWORD: `${V1_USERS_PREFIX}/me/password`,

  USER_PROFILE_DATA_GET: (id: number) => `${V1_PROFILE_FIELDS_PREFIX}/by-user/${id}`,
  USER_PROFILE_DATA_UPDATE: (id: number) => `${V1_USERS_PREFIX}/${id}/profile-data`,

  PASSWORD_HISTORY: (id: number) => `${V1_USERS_PREFIX}/${id}/password-history`,
  PROFILE_IMAGE: (id: number) => `${V1_USERS_PREFIX}/${id}/profile-image`,
  USERS_BULK_ACTIONS: `${V1_USERS_PREFIX}/bulk-actions`,
  USERS_EXPORT: `${V1_USERS_PREFIX}/export`,

  PROFILE_FIELDS: `${V1_PROFILE_FIELDS_PREFIX}/`,
  PROFILE_FIELD_DETAIL: (id: number) => `${V1_PROFILE_FIELDS_PREFIX}/${id}`,
  PROFILE_FIELDS_BY_USER: (userId: number) => `${V1_PROFILE_FIELDS_PREFIX}/by-user/${userId}`,
  PROFILE_FIELDS_EXPORT: `${V1_PROFILE_FIELDS_PREFIX}/export`,

  PROFILE_FIELDS_CATEGORIES: `${V1_PROFILE_FIELDS_PREFIX}/categories`,
  PROFILE_FIELD_CATEGORY_DETAIL: (id: number) => `${V1_PROFILE_FIELDS_PREFIX}/categories/${id}`,
  PROFILE_FIELDS_CATEGORIES_EXPORT: `${V1_PROFILE_FIELDS_PREFIX}/categories/export`,

  ACTIVITY_SUMMARY: (id: number | string) => `${V1_USERS_PREFIX}/${id}/activity-summary`,
  ACTIVITY_HISTORY: (id: number | string) => `${V1_USERS_PREFIX}/${id}/activity-history`,
  MY_LEARNING: `${V1_USERS_PREFIX}/me/my-learning`,
  USER_LEARNING: (id: number | string) => `${V1_USERS_PREFIX}/${id}/learning`,
  MY_COURSE_PROGRESS: `${V1_USERS_PREFIX}/me/course-progress`,

  STREAK: (id: number | string) => `${V1_USERS_PREFIX}/${id}/streak`,
  STREAK_SETTINGS: `${V1_USERS_PREFIX}/streaks/settings`,
  STREAK_MILESTONES: `${V1_USERS_PREFIX}/streaks/milestones`,
  STREAK_MILESTONE_DETAIL: (id: number | string) => `${V1_USERS_PREFIX}/streaks/milestones/${id}`,

  MY_PREFERENCES: `${V1_USERS_PREFIX}/me/preferences`,

  // Upload Users
  USER_UPLOAD_TEMPLATE: `${V1_USERS_PREFIX}/upload/template`,
  USER_UPLOAD_DRY_RUN: `${V1_USERS_PREFIX}/upload/dry-run`,
  USER_UPLOAD_CONFIRM: `${V1_USERS_PREFIX}/upload/confirm`,
  USER_UPLOAD_LOGS: `${V1_USERS_PREFIX}/upload/import-logs`,
  USER_UPLOAD_LOGS_EXPORT: `${V1_USERS_PREFIX}/upload/import-logs/export`,

  // Upload Pictures
  USER_PICTURE_VALIDATE: `${V1_USERS_PREFIX}/upload-pictures/validate`,
  USER_PICTURE_CONFIRM: `${V1_USERS_PREFIX}/upload-pictures/confirm`,
  USER_PICTURE_LOGS: `${V1_USERS_PREFIX}/upload-pictures/logs`,

  // Ad-hoc Messaging
  ADHOC_RESOLVE_RECIPIENTS: `${API_PREFIX}/adhoc-messages/resolve-recipients`,
  ADHOC_SEND: `${API_PREFIX}/adhoc-messages/send`,
  ADHOC_MESSAGES: `${API_PREFIX}/adhoc-messages/`,
  ADHOC_MESSAGE_DETAIL: (id: string) => `${API_PREFIX}/adhoc-messages/${id}`,
  ADHOC_MESSAGE_EXPORT: (id: string) => `${API_PREFIX}/adhoc-messages/${id}/export`,
};